export default "__VITE_ASSET__aa434b13__"